import { Thread } from "@/components/assistant-ui/thread";
import { ContentSlideAlphaCreateRuntime } from "../../components/ContentSlideAlphaCreateRuntime";

export default function TimePeriodBenchmarkStep() {
  return (
    <div className="h-full rounded-md">
        <ContentSlideAlphaCreateRuntime>
          <Thread />
        </ContentSlideAlphaCreateRuntime>
    </div>
  );
}
